import React, { ReactNode } from 'react';

import { setConfigOnce } from 'utils/config';

type Props = {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  config: Record<string, any>;
  children: ReactNode;
};

export function WithConfig({ config, children }: Props) {
  setConfigOnce(config);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
}
